import { render, staticRenderFns } from "./Cuento.vue?vue&type=template&id=0a124a40&scoped=true&"
import script from "./Cuento.vue?vue&type=script&lang=js&"
export * from "./Cuento.vue?vue&type=script&lang=js&"
import style0 from "./Cuento.vue?vue&type=style&index=0&id=0a124a40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a124a40",
  null
  
)

export default component.exports